import { getIntelligenceCommonStyles } from './intelligence-common-style';

export const getMatchReportStyles = (_, { palette = {} }) => ({
  '@global': {
    '.bingads-campaign-react-sub-page-menu': {
      '& .compared-date-range-picker': {
        display: 'none',
      },
    },
  },

  MatchReport: {
    marginLeft: '32px',
    marginTop: '32px',
    display: 'flex',
    overflow: 'auto',
    flex: '1 0 1px',
    flexDirection: 'column',

    '& .match-report-container': {
      '& .match-report-desc:first-child': {

        '& .match-report-title': {
          display: 'none',
        },

        '& .match-report-desc': {
          marginBottom: '34px',

          '& h5': {
            marginTop: '15px',
            marginBottom: '15px',
            fontSize: '14px',
            fontWeight: 'normal',
          },
        },

        '& .match-report-result-container': {

          '& .form-group:nth-child(1)': {
            marginBottom: '33px',

            '& label': {
              float: 'none',
            },

            '& .col-sm-10': {
              fontWeight: 'normal',
            },
          },

          '& .form-group:nth-child(2)': {
            marginBottom: '33px',

            '& label': {
              float: 'none',
            },

            '& .col-sm-2': {
              fontSize: '16px',
            },

            '& .col-sm-10 label': {
              fontWeight: 'normal',
              paddingTop: '0px',
              paddingBottom: '0px',
            },
          },
        },
      },
      ...getIntelligenceCommonStyles(_, { palette }),
    },
  },
});
